<app-modal-basic #addTransportationCostModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.invoice_dealer.show.transportation_cost'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="hideCollectionTransportationCostModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addTransportationCostForm="ngForm">
      <p>{{'admin.invoice_dealer.show.transportation_cost_modal_description'|translate}}</p>
      <p>{{'admin.invoice_dealer.show.transportation_cost_row'|translate}}</p>
      <hr>
      <ng-container *ngFor="let collectionTransportationCost of collectionTransportationCosts; let i=index">
        <div class="row">
          <div class="form-group col-md-3">
            <label
              [for]="'collection' + i">{{'doctrine.invoice_dealer.transportation_cost.collection_name' | translate}}
              <span
                class="star">*</span></label>
            <ng-select required
                       [clearable]="false"
                       #collection="ngModel"
                       [name]="'collection' + i"
                       [id]="'collection' + i"
                       [items]="getCollections(collectionTransportationCost.collection)"
                       bindLabel="label"
                       bindValue="value"
                       [addTag]="false"
                       [hideSelected]="true"
                       [(ngModel)]="collectionTransportationCost.collection">
            </ng-select>
            <div class="messages text-danger"
                 *ngIf="collection.invalid && collection.dirty && collection.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-3">
            <label [for]="'cost' + i">{{'doctrine.invoice_dealer.transportation_cost.cost' | translate}}<span
              class="star">*</span></label>
            <input required
                   [name]="'cost' + i"
                   [id]="'cost' + i"
                   class="form-control"
                   #cost="ngModel"
                   type="number"
                   [(ngModel)]="collectionTransportationCost.cost">
            <span class="form-bar"></span>
            <div class="messages text-danger"
                 *ngIf="cost.invalid && cost.dirty && cost.errors?.required">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="col-sm-3">
            <label [for]="'multiplier' + i"
                   class="float-label">{{'doctrine.invoice_dealer.transportation_cost.multiplier'|translate}}<span
              class="star">*</span></label>
            <ng-select required
                       [clearable]="false"
                       #priceMultiplierItems="ngModel"
                       [name]="'multiplier' + i"
                       [id]="'multiplier' + i"
                       [items]="properties"
                       bindLabel="name"
                       bindValue="id"
                       [addTag]="false"
                       [hideSelected]="true"
                       [(ngModel)]="collectionTransportationCost.multiplier">
            </ng-select>
            <div class="messages text-danger"
                 *ngIf="priceMultiplierItems.invalid && priceMultiplierItems.dirty">
              {{'errors.required'|translate}}
            </div>
          </div>
          <div class="form-group col-md-3 mt-4">
            <a class="btn btn-lg btn-primary btn-icon ripple light ms-1"
               (click)="removeCollectionTransportationCostItem(i)">
              <i class="fa fa-remove"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="description">{{'doctrine.invoice_dealer.transportation_cost.description' | translate}}<span
            class="star">*</span></label>
          <input [required]="collectionTransportationCosts.length > 0"
                 name="description"
                 id="description"
                 class="form-control"
                 #descriptionModel="ngModel"
                 type="text"
                 [(ngModel)]="description">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="descriptionModel.invalid && descriptionModel.dirty && descriptionModel.errors?.required">
            {{'errors.required'|translate}}
          </div>
        </div>
      </div>
      <button class="btn btn-primary ripple light mb-0 mt-0" (click)="addCollectionTransportationCostItem()">
        <i class="fa fa-plus"></i>
        &nbsp;{{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideCollectionTransportationCostModal()">{{'global.cancel'|translate}}</button>
    <button class="btn btn-primary ripple light" type="button"
            (click)="SaveTransportationCosts()" [disabled]="!addTransportationCostForm.valid">
      {{'global.actions.save' | translate}}
    </button>
  </div>
</app-modal-basic>
